import React, { useState } from 'react';
import { useParams, Link as RouterLink } from 'react-router-dom';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import LockRoundedIcon from '@mui/icons-material/LockRounded';
import PixCheckout from '../../components/PixCheckout';
import tokens from '../../theme/tokens';

const nomeProvedor = { mercadopago: 'Mercado Pago', asaas: 'Asaas', simulado: 'provedor de teste' };

// Página pública do link enviado por e-mail: gera o PIX e acompanha a confirmação do pagamento.
const PaymentPage = () => {
  const { token } = useParams();
  const [payment, setPayment] = useState(null);

  return (
    <Box sx={{ minHeight: '100vh', py: { xs: 3, sm: 6 }, px: 2, background: `linear-gradient(180deg, ${tokens.color.ink} 0, ${tokens.color.ink} 260px, ${tokens.color.bg} 260px)` }}>
      <Box sx={{ maxWidth: 460, mx: 'auto' }}>
        <Stack direction="row" alignItems="center" spacing={1.5} sx={{ color: '#fff', mb: 3 }}>
          <Box sx={{ width: 44, height: 44, borderRadius: '50%', bgcolor: '#fff', display: 'grid', placeItems: 'center' }}>
            <Box component="img" src="/logo_rfc.png" alt="Riviera FC" sx={{ width: 38 }} />
          </Box>
          <Box>
            <Typography sx={{ fontFamily: tokens.font.display, fontWeight: 700, fontSize: '1.3rem', lineHeight: 1 }}>RIVIERA FC</Typography>
            <Typography variant="body2" sx={{ opacity: 0.7 }}>Pagamento de mensalidade</Typography>
          </Box>
        </Stack>

        <Card sx={{ p: { xs: 2.5, sm: 3.5 } }}>
          <PixCheckout
            token={token}
            onLoad={setPayment}
            acaoPago={<Button component={RouterLink} to="/painel" variant="contained">Ir para o painel</Button>}
          />
        </Card>

        <Stack direction="row" spacing={1} alignItems="center" justifyContent="center" sx={{ mt: 2, color: 'text.secondary' }}>
          <LockRoundedIcon fontSize="small" />
          <Typography variant="caption">Pagamento processado por {nomeProvedor[payment?.provider] || 'parceiro de pagamentos'} · confirmação automática</Typography>
        </Stack>
      </Box>
    </Box>
  );
};

export default PaymentPage;
